export const TEAM_COLORS: Record<string, { main: string; sub: string }> = {
    // NPB
    yomiuri_giants: { main: '#F58220', sub: '#000000' },
    hanshin_tigers: { main: '#FFE100', sub: '#000000' },
    yokohama_dena_baystars: { main: '#0052CD', sub: '#FFFFFF' },
    hiroshima_toyo_carp: { main: '#C8102E', sub: '#FFFFFF' },
    tokyo_yakult_swallows: { main: '#002F6C', sub: '#FFFFFF' },
    chunichi_dragons: { main: '#00468B', sub: '#FFFFFF' },
    orix_buffaloes: { main: '#041E42', sub: '#FFFFFF' },
    fukuoka_softbank_hawks: { main: '#F5D100', sub: '#000000' },
    saitama_seibu_lions: { main: '#003DA5', sub: '#FFFFFF' },
    tohoku_rakuten_golden_eagles: { main: '#870038', sub: '#FFFFFF' },
    chiba_lotte_marines: { main: '#000000', sub: '#FFFFFF' },
    hokkaido_nipponham_fighters: { main: '#0066C0', sub: '#FFFFFF' },

    // MLB - AL East
    new_york_yankees: { main: '#0C2340', sub: '#FFFFFF' },
    boston_red_sox: { main: '#BD3039', sub: '#FFFFFF' },
    toronto_blue_jays: { main: '#134A8E', sub: '#FFFFFF' },
    tampa_bay_rays: { main: '#092C5C', sub: '#FFFFFF' },
    baltimore_orioles: { main: '#DF4601', sub: '#000000' },

    // MLB - AL Central
    chicago_white_sox: { main: '#27251F', sub: '#FFFFFF' },
    cleveland_guardians: { main: '#00385D', sub: '#FFFFFF' },
    detroit_tigers: { main: '#0C2340', sub: '#FFFFFF' },
    kansas_city_royals: { main: '#004687', sub: '#FFFFFF' },
    minnesota_twins: { main: '#002B5C', sub: '#FFFFFF' },

    // MLB - AL West
    houston_astros: { main: '#002D62', sub: '#FFFFFF' },
    texas_rangers: { main: '#003278', sub: '#FFFFFF' },
    los_angeles_angels: { main: '#BA0021', sub: '#FFFFFF' },
    seattle_mariners: { main: '#0C2C56', sub: '#FFFFFF' },
    oakland_athletics: { main: '#003831', sub: '#FFFFFF' },

    // MLB - NL East
    atlanta_braves: { main: '#13274F', sub: '#FFFFFF' },
    philadelphia_phillies: { main: '#E81828', sub: '#FFFFFF' },
    new_york_mets: { main: '#002D72', sub: '#FFFFFF' },
    miami_marlins: { main: '#000000', sub: '#FFFFFF' },
    washington_nationals: { main: '#AB0003', sub: '#FFFFFF' },

    // MLB - NL Central
    chicago_cubs: { main: '#0E3386', sub: '#FFFFFF' },
    st_louis_cardinals: { main: '#C41E3A', sub: '#FFFFFF' },
    milwaukee_brewers: { main: '#12284B', sub: '#FFFFFF' },
    cincinnati_reds: { main: '#C6011F', sub: '#FFFFFF' },
    pittsburgh_pirates: { main: '#27251F', sub: '#FFFFFF' },

    // MLB - NL West
    los_angeles_dodgers: { main: '#005A9C', sub: '#FFFFFF' },
    san_francisco_giants: { main: '#FD5A1E', sub: '#000000' },
    san_diego_padres: { main: '#2F241D', sub: '#FFFFFF' },
    arizona_diamondbacks: { main: '#A71930', sub: '#FFFFFF' },
    colorado_rockies: { main: '#33006F', sub: '#FFFFFF' },
};
